import { oneEngineOil, registerEngineOilMetadata, clearEngineOilMetadata, appointmentCartKey } from '@/utils/engineOilCart';
import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";
import apiRequest from "./../services/apiRequest";
import snackbar from "./modules/snackbar";
import auth from "./modules/auth";
import { getApiErrorMessage } from "@/components/utilities/commonMixin.js";
const STORAGE_KEY = "vuex";
const laborTypesRequests = new Map();

try {
  localStorage.removeItem(STORAGE_KEY);
} catch (error) {
  console.warn("Unable to clear persisted Vuex state:", error);
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    persistedState: {
      ...(state.persistedState || {}),
      ...(state.auth || {}),
    },
    auth: state.auth,
  }),
});

const store = {
  state: {
    cartAppointmentKey: "",
    persistedState: {},
    vinScanData: {},
    previewVideoUrl: "",
    walkAroundVideoFile: null,
    packageServiceDetail: {},
    cartItems: [],
    servicesItems: [],
    advisorsData: [],
    laborTypes: [],
    laborTypesStoreId: null,
     selectedItems: [],
      storeId: null,
     
     
      

  },
  getters: {
    getPreviewVideoUrl: (state) => state.previewVideoUrl,
    getWalkAroundVideoFile: (state) => state.walkAroundVideoFile,
    getVinScanData: (state) => state.vinScanData,
    getPackageServiceDetail: (state) => state.packageServiceDetail,
    getCartItems: (state) => state.cartItems,
    getServicesItems: (state) => state.servicesItems,
    getAdvisorsData: (state) => state.advisorsData,
    getLaborTypes: (state) => state.laborTypes,
    getSelectedItems: (state) => state.selectedItems,
    getStoreId: (state) => state.storeId,
    
  },
  mutations: {
    RESET_APPOINTMENT_CART(state) {
      state.cartItems = [];
      state.selectedItems = [];
      state.servicesItems = [];
      state.packageServiceDetail = {};
      state.vinScanData = {};
      state.previewVideoUrl = '';
      state.walkAroundVideoFile = null;
      state.cartAppointmentKey = '';
      clearEngineOilMetadata();
    },
    logout(state) {
      //clear local storage
      localStorage.clear();
      delete state.persistedState;
      delete state.auth;
    },

    SET_PREVIEW_VIDEO_URL(state, data) {
      state.previewVideoUrl = data;
    },
    SET_WALKAROUND_VIDEO_FILE(state, data) {
      state.walkAroundVideoFile = data;
    },
      SET_LABOR_TYPES(state, data) {
        console.debug("[labor-types] Vuex before mutation", {
          storeId: state.laborTypesStoreId,
          count: Array.isArray(state.laborTypes) ? state.laborTypes.length : 0,
          at: new Date().toISOString(),
        });
        state.laborTypes = Array.isArray(data?.items) ? data.items : data;
        state.laborTypesStoreId = data?.storeId ?? state.laborTypesStoreId;
        console.debug("[labor-types] Vuex after mutation", {
          storeId: state.laborTypesStoreId,
          count: Array.isArray(state.laborTypes) ? state.laborTypes.length : 0,
          at: new Date().toISOString(),
        });
      },
      CLEAR_LABOR_TYPES(state) {
        state.laborTypes = [];
        state.laborTypesStoreId = null;
    },
    SET_VIN_SCAN_DATA(state, data) {
      const key = appointmentCartKey(data);
      if (key && key !== state.cartAppointmentKey) {
        state.cartItems = [];
        state.selectedItems = [];
        state.servicesItems = [];
        state.packageServiceDetail = {};
        state.previewVideoUrl = '';
        state.walkAroundVideoFile = null;
        clearEngineOilMetadata();
      }
      if (key) state.cartAppointmentKey = key;
      state.vinScanData = data;
    },
    SET_PACKAGES_SERVICE_DETAIL(state, data) {
      state.packageServiceDetail = data;
    },
    SET_CART_ITEMS(state, data) {
      console.debug("[cart] Vuex before mutation", {
        count: Array.isArray(state.cartItems) ? state.cartItems.length : 0,
        at: new Date().toISOString(),
      });
      registerEngineOilMetadata(data);
      state.cartItems = oneEngineOil(data);
      console.debug("[cart] Vuex after mutation", {
        count: Array.isArray(state.cartItems) ? state.cartItems.length : 0,
        laborTypes: Array.isArray(state.cartItems)
          ? state.cartItems.map((item) => item?.laborType ?? null)
          : [],
        at: new Date().toISOString(),
      });
    },
    SET_SERVICES_ITEMS(state, data) {
      state.servicesItems = data;
    },
    SET_ADVISORS_DATA(state, data) {
      state.advisorsData = data;
    },
    SET_SELECTED_ITEMS(state, data) {
      registerEngineOilMetadata(data);
      state.selectedItems = oneEngineOil(data);
    },
SET_STORE_ID(state, data) {
  state.storeId = data;
},

  },
  actions: {
    async loadLaborTypes({ state, commit, dispatch }, storeId) {
      const normalizedStoreId = storeId == null ? "" : String(storeId).trim();
      if (!normalizedStoreId) {
        console.warn("[labor-types] skipped request: store ID is missing");
        commit("CLEAR_LABOR_TYPES");
        return [];
      }

      if (
        state.laborTypesStoreId === normalizedStoreId &&
        Array.isArray(state.laborTypes) &&
        state.laborTypes.length
      ) {
        console.debug("[labor-types] using cached list", {
          storeId: normalizedStoreId,
          count: state.laborTypes.length,
          at: new Date().toISOString(),
        });
        return state.laborTypes;
      }

      if (laborTypesRequests.has(normalizedStoreId)) {
        return laborTypesRequests.get(normalizedStoreId);
      }

      const url = `getLaborTypes/${encodeURIComponent(normalizedStoreId)}`;
      console.debug("[labor-types] request", {
        url,
        storeId: normalizedStoreId,
        at: new Date().toISOString(),
      });

      const request = dispatch("readData", url)
        .then((response) => {
          const laborTypes = Array.isArray(response?.data?.data)
            ? response.data.data
            : Array.isArray(response?.data?.data?.labor_types)
              ? response.data.data.labor_types
              : [];

          console.debug("[labor-types] response", {
            storeId: normalizedStoreId,
            count: laborTypes.length,
            at: new Date().toISOString(),
          });

          if (state.storeId == null || String(state.storeId) === normalizedStoreId) {
            commit("SET_LABOR_TYPES", {
              items: laborTypes,
              storeId: normalizedStoreId,
            });
          }
          return laborTypes;
        })
        .catch((error) => {
          console.error("[labor-types] request failed", {
            storeId: normalizedStoreId,
            status: error?.response?.status,
            at: new Date().toISOString(),
          });
          throw error;
        })
        .finally(() => {
          laborTypesRequests.delete(normalizedStoreId);
        });

      laborTypesRequests.set(normalizedStoreId, request);
      return request;
    },
    /**
     * This function is used to show snackbar for both cases i.e. success or error
     *
     * @param response
     * @returns void
     */
    handleSnackBar(context, response) {
      console.log("handleSanckbar is ", response);
      let message,
        color = "error";
      if (
        typeof response?.data?.message === "string" &&
        response.data.message.trim()
      ) {
        color = "success";
        message = response.data.message.trim();
      } else {
        message = getApiErrorMessage(response, "Something went wrong");
      }
      context.commit("set_snack_data", {
        message,
        color,
        snackbar: true,
      });
    },
    /**
     * This method is responsible to read data
     *
     * @param {String} url
     * @return promise
     */
    readData(context, url) {
      const appointmentKey = context.state.cartAppointmentKey;
      return new Promise((resolve, reject) => {
        let done = async (response) => {
          if (response.status == 200 || response.status == 202) {
            if (appointmentKey === context.state.cartAppointmentKey) registerEngineOilMetadata(response?.data);
            resolve(response);
          } else {
            context.dispatch("handleSnackBar", response);
            reject(response);
          }
        };
        apiRequest.get(url, done);
      });
    },
    /**
     * This method is responsible to make an api call to read data for post request
     *
     * @param {Object} payload contain url and data
     * @return promise
     */
    readPostData(context, payload) {
      return new Promise((resolve, reject) => {
        let done = async (response) => {
          if (response.status == 200) {
            registerEngineOilMetadata(response?.data);
            resolve(response);
          } else {
            context.dispatch("handleSnackBar", response);
            reject(response);
          }
        };
        apiRequest.post(payload.url, payload.data, done);
      });
    },
    /**
     * This method is responsible to make an api call to add/update/delete data for post request
     *
     * @param {Object} payload contain url and data
     * @return promise
     */
    postData(context, payload) {
      return new Promise((resolve, reject) => {
        let done = async (response) => {
          if (response.status == 200 || response.status == 201) {
            registerEngineOilMetadata(response?.data);
            resolve(response);
          } else {
            context.dispatch("handleSnackBar", response);
            reject(response);
          }
        };
        apiRequest.post(payload.url, payload.data, done);
      });
    },
    /**
     * This function is used to get latest data on page refresh
     *
     * @returns void
     */
    getUserData(context) {
      return new Promise((resolve, reject) => {
        let done = async (response) => {
          if (response.status == 200) {
            context.commit("SET_USER_DATA", response.data.data?.user);
            registerEngineOilMetadata(response?.data);
            resolve(response);
          } else {
            reject(response);
          }
        };
        apiRequest.get("getUserData", done);
      });
    },

    getAllAdvisorsData(context) {
      return new Promise((resolve, reject) => {
        let done = async (response) => {
          if (response.status == 200) {
            context.commit("SET_ADVISORS_DATA", response.data.data?.users);
            registerEngineOilMetadata(response?.data);
            resolve(response);
          } else {
            reject(response);
          }
        };
        apiRequest.get("readUsers?role=advisor", done);
      });
    },
  },

  plugins: [vuexLocal.plugin],
  modules: {
    snackbar,
    auth,
  },
};

export default createStore(store);
